(function($) {
    var defaults = {
      "hamburgerId": "sm_menu_ham",
      "wrapperClass": "sm_menu_outer",
      "submenuClass": "submenu",
      "menuStyle": "slide",
      "onMenuLoad": function() { return true; },
      "onMenuToggle": function() { return true; }
    };
  
    $.fn.simpleMobileMenu = function(options) {
      if (this.length === 0) { return this; }
  
      var smMenu = {},
          ds = $(this);
  
      var init = function() {
        smMenu.settings = $.extend({}, defaults, options);
        smMenu.styleClass = smMenu.settings.menuStyle.toLowerCase() === 'slide' ? "slide" : "accordion";
  
        smMenu.smmOuter = $("." + smMenu.settings.wrapperClass); // Find the existing wrapper
        ds.addClass(smMenu.styleClass); // Add the style class to the unordered list
  
        createBackButton();
  
        $("#" + smMenu.settings.hamburgerId).on('click keydown', toggleMobileMenu);
  
        if (typeof smMenu.settings.onMenuLoad === 'function') {
          smMenu.settings.onMenuLoad(ds);
        }
      };
  
      var createBackButton = function() {
        smMenu.smmOuter.find("ul." + smMenu.settings.submenuClass).each(function() {
          var dis = $(this),
              disPar = dis.closest("li"),
              disfA = disPar.find("> a"),
              disBack = $("<li/>", {
                "class": "back",
                "html": "<a href='#'>" + disfA.text() + "</a>"
              });
          disPar.addClass("hasChild");
          if (smMenu.styleClass === 'slide') {
            disBack.prependTo(dis);
          }
        });
      };
  
      var toggleMobileMenu = function(e) {
        if (e.type === 'click' || e.keyCode === 13 || e.keyCode === 32) {
          e.preventDefault();
          var $hamburger = $("#" + smMenu.settings.hamburgerId);
          $hamburger.toggleClass("open");
          smMenu.smmOuter.toggleClass("active").find("li.active").removeClass("active");
          $("body").toggleClass("mmactive");
  
          var isExpanded = $hamburger.attr('aria-expanded') === 'true';
          $hamburger.attr('aria-expanded', String(!isExpanded));
  
          if (smMenu.styleClass === 'accordion') {
            smMenu.smmOuter.find("ul." + smMenu.settings.submenuClass).hide();
          }
  
          if (typeof smMenu.settings.onMenuToggle === 'function') {
            smMenu.settings.onMenuToggle(ds, $hamburger.hasClass("open"));
          }
        }
      };
  
      $(document).on('keydown', function(e) {
        if (e.keyCode === 27) {
          var $hamburger = $("#" + smMenu.settings.hamburgerId);
          if($hamburger.hasClass("open")) {
            toggleMobileMenu(e);
          }
        }
      });
  
      var showSlideSubMenu = function(e) {
        e.preventDefault();
        $(this).parent().addClass("active").siblings().removeClass("active");
        smMenu.smmOuter.scrollTop(0);
      };
  
      var showAccordionSubMenu = function(e) {
        e.preventDefault();
        var dis = $(this),
            dispar = dis.parent(),
            lastActive = dispar.siblings(".active");
  
        dispar.find("> ." + smMenu.settings.submenuClass).slideToggle(function() {
          if ($(this).is(":visible")) {
            var offset = dis[0].offsetTop;
            smMenu.smmOuter.stop().animate({ scrollTop: offset }, 300);
          }
        });
  
        lastActive.find("ul." + smMenu.settings.submenuClass).slideUp(function() {
          $(this).parent().removeClass("active");
        });
  
        dispar.toggleClass("active").siblings().removeClass("active");
      };
  
      var goBack = function(e) {
        e.preventDefault();
        $(this).closest("ul." + smMenu.settings.submenuClass).parent().removeClass("active");
      };
  
      init();
  
      smMenu.smmOuter.find("li.hasChild > a").on('click', function(e) {
        if (smMenu.styleClass === 'slide') {
          showSlideSubMenu.call(this, e);
        } else if (smMenu.styleClass === 'accordion') {
          showAccordionSubMenu.call(this, e);
        }
      });
  
      smMenu.smmOuter.find("li.back a").on('click', goBack);
  
      return this;
    };
  })(jQuery);
  